module.exports = __webpack_public_path__ + "assets/img/jobDictionary_expired.jpg";